const CURRENCY_SYMBOLS_MAP = {
  RUB: '₽',
  USD: '$',
  EUR: '€',
};

const unitsMap = {
  [1000000000000]: 'трлн.',
  [1000000000]: 'млрд.',
  [1000000]: 'млн.',
  [1000]: 'тыс.',
};

export const numberThousandsSeparator = value => {
  return value
    .toString()
    .replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ')
    .replace('.', ',');
};

export const numberToReadableFormat = (num, currency) => {
  if (num < 1000000) {
    return `${numberThousandsSeparator(num.toFixed(2))} ${
      CURRENCY_SYMBOLS_MAP[currency] || currency
    }`;
  }

  let formattedNumber = '';

  for (const key in unitsMap) {
    if (num >= key) {
      formattedNumber = `${(num / key)
        .toFixed(2)
        .toString()
        .replace('.', ',')} ${unitsMap[key]} ${
        CURRENCY_SYMBOLS_MAP[currency] || currency
      }`;
    }
  }

  return formattedNumber;
};
